import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main'
import Privacy from '@/pages/Privacy'
import Supported from '@/pages/SupportedUrl'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/supported',
      name: 'Supported',
      component: Supported
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js